import Head from 'next/head'
import { AppLayout } from '@components'
import { NextSeo } from 'next-seo'
import { Hero } from '@partials/tech-summit/Hero'
import { ReasonsToAttend } from '@partials/tech-summit/ReasonsToAttend'
import { Speakers } from '@partials/tech-summit/Speakers'
import { Topics } from '@partials/tech-summit/Topics'
import { PreviousEvents } from '@partials/tech-summit/PreviousEvents'
import { Registration } from '@partials/tech-summit/Registration'
import { Marquee } from '@partials/tech-summit/Marquee'
import { Agenda } from '@partials/tech-summit/Agenda'
import { GetStaticProps } from 'next'
import { getGraphQLData } from 'database/graphQL/apollo'
import { querySummitSpeakers } from 'database/graphQL/queries/querySummitSpeakers'
import { RegistrationCallout } from '@partials/tech-summit/RegistrationCallout'

export interface ISpeaker {
  name: string
  role: string
  image: any
  slug: string
  bio: any
}

export const getStaticProps: GetStaticProps = async () => {
  const response = await getGraphQLData<{ allSummitSpeakers: ISpeaker[] }>(
    querySummitSpeakers,
  )

  return {
    props: { speakers: response?.allSummitSpeakers || null },
    revalidate: 10,
  }
}

export default function Summit({ speakers }: { speakers: ISpeaker[] }) {
  return (
    <AppLayout showBanner={false}>
      <NextSeo
        title="2023 Technology & Innovation Summit"
        canonical={'https://www.marketxventures.com/summit'}
        description="A global forum to exchange ideas about the most innovative areas of global finance."
        openGraph={{
          url: 'https://www.marketxventures.com/summit',
          title: '2023 Technology & Innovation Summit | MarketX Ventures',
          description:
            'A global forum to exchange ideas about the most innovative areas of global finance.',
          siteName:
            '2023 Technology &amp; Innovation Summit | MarketX Ventures',
          images: [
            {
              url: 'https://www.marketxventures.com/images/open-graph/summit-meta-image.jpg',
              width: 800,
              height: 418,
              alt: 'MarketX Ventures Summit',
              type: 'image/jpeg',
            },
          ],
        }}
      />
      <Head>
        <meta
          name="description"
          content="A global forum to exchange ideas about the most innovative areas of global finance."
        />
      </Head>
      <main>
        <Hero />
        <ReasonsToAttend />
        <RegistrationCallout copyIndex={0} />
        <Speakers speakers={speakers} />
        <RegistrationCallout copyIndex={1} />
        <Topics />
        <RegistrationCallout copyIndex={2} />
        <PreviousEvents />
        <Agenda />
        <Marquee />
        <Registration />
      </main>
    </AppLayout>
  )
}
